import React from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { HeartOutlined, ShoppingCartOutlined, UserOutlined } from '@ant-design/icons';
import FilterIcon from '../icons/FilterIcon';
import { Badge } from 'antd';
import { useAppStore, useFilterControl } from '../store/Store';

const Topbar = ({ currentPage, onNavigate, onIconClick }) => {
  const location = useLocation();
  const { wishlistCount, cartCount } = useAppStore();
  const { hasAppliedFilters } = useFilterControl();

  const navItems = [
    { key: "shop", label: "Shop" },
    { key: "about", label: "About" },
    { key: "contact", label: "Contact" },
  ];

  const showFilter = location.pathname === '/' || location.pathname === '/shop';


  return (
    <Box sx={{ width: '100%', height: {xs:'48px',sm:'72px'}, bgcolor: '#fff', display: 'flex', justifyContent: 'center', boxShadow: '0 1px 5px rgba(0,0,0,0.05)', position: 'fixed', top: 0, left: 0, zIndex: 1000 }}>
      <Box sx={{ width: '100%', maxWidth: '1280px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: { xs: 2 }, position: 'relative' }}>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {showFilter && (
            <Box sx={{ display: { xs: 'flex', sm: 'none' }, alignItems: 'center', mr: 1 }} onClick={() => onIconClick('filter')}>
              <Badge dot={hasAppliedFilters()}> <FilterIcon style={{ fontSize: '22px', color: '#9ca3af', cursor: 'pointer' }} /> </Badge>
            </Box>
          )}
          <Box sx={{ display: { xs: 'none', sm: 'block' }, fontSize: { xs: '20px', sm: '24px', md: '28px' }, cursor: 'pointer', fontFamily:'Shrikhand', color:'#2B2B2B', userSelect: 'none' }} onClick={() => onNavigate('shop')}>
            Cuty Bird
          </Box>
        </Box>

        <Box sx={{ display: { xs: 'block', sm: 'none' }, position: 'absolute', left: '50%', transform: 'translateX(-50%)', fontSize: { xs: '20px', sm: '24px', md: '28px' }, fontWeight: 'bold', cursor: 'pointer', fontFamily:'Shrikhand', color:'#494646ff', userSelect: 'none' }} onClick={() => onNavigate('shop')}>
          Cuty Bird
        </Box>

        <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', height: '100%' }}>
          {navItems.map((item) => (
            <Box
              key={item.key}
              onClick={() => onNavigate(item.key)}
              sx={{
                px: 3, height: '100%', display: 'flex', alignItems: 'center', cursor: 'pointer', position: 'relative', userSelect: 'none',
                color: currentPage === item.key ? '#000' : '#666', fontWeight: 600, fontSize: '14px', transition: 'color 0.2s ease',
                '&:hover': { color: '#000' },
                '&::after': {
                  content: '""', position: 'absolute', bottom: '18px', left: '50%', transform: 'translateX(-50%)',
                  width: currentPage === item.key ? '55%' : 0, height: '2px', bgcolor: '#000', borderRadius: '1px', transition: 'width 0.2s ease'
                },
                '&:hover::after': { width: '55%' }
              }}
            >
              {item.label}
            </Box>
          ))}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, userSelect: 'none' }}>
          <Box sx={{ display: { xs: 'none', sm: 'flex' }, cursor:'pointer' }} onClick={() => onIconClick('wishlist')}>
            <Badge count={wishlistCount} size="small" offset={[-6, 6]} showZero={false}>
              <Box sx={{ padding: '8px', borderRadius: '8px', transition: 'all 0.3s ease', '&:hover': { backgroundColor: 'rgba(107,114,128,0.1)', transform: 'scale(1.1)' } }}>
                <HeartOutlined style={{ fontSize: '20px', color: '#9ca3af' }} />
              </Box>
            </Badge>
          </Box>

          <Box sx={{ display: { xs: 'none', sm: 'flex' }, cursor:'pointer', userSelect: 'none' }} onClick={() => onIconClick('cart')}>
            <Badge count={cartCount} size="small" offset={[-6,6]} showZero={false}>
              <Box sx={{ padding: '8px', borderRadius: '8px', transition: 'all 0.3s ease', '&:hover': { backgroundColor: 'rgba(107,114,128,0.1)', transform: 'scale(1.1)' } }}>
                <ShoppingCartOutlined style={{ fontSize: '20px', color: '#9ca3af' }} />
              </Box>
            </Badge>
          </Box>

          <Box sx={{ padding: '8px', borderRadius: '8px', transition: 'all 0.3s ease', userSelect: 'none', '&:hover': { backgroundColor: 'rgba(107,114,128,0.1)', transform: 'scale(1.1)' }, cursor:'pointer' }} onClick={() => onIconClick('user')}>
            <UserOutlined style={{ fontSize: '20px', color: '#9ca3af' }} />
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default Topbar;